import React, { PureComponent } from "react";

import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Icon,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Table,
  Tabs,
  Tag,
  Tooltip,
  DatePicker
} from "antd";
import _ from "lodash";
import Moment from "moment";
import Each from "async/each";

import { connect } from "react-redux";
import Request, { API_URL, LAPI_URL } from "../../../../request";

import StudentHeader from "../../../../components/studentHeader";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
// import GetAllFormFields from '../../../components/_utils/formUtils'
import AddBranch from "../../../../containers/Masters/branch/add/index";
import style from "./styles.less";
import Quali from "../../../../components/qualification";
import { hideLoader, showLoader } from "../../../../modules/actions";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import Exception from "../../../../components/Exception";
import { Link } from "react-router-dom";
import Webcam from "react-webcam";
import rightAuth from '../../../../components/_utils/userRights'
import moment from "moment";
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
  imageSmoothing: false,
};
const { TextArea } = Input;
const TabPane = Tabs.TabPane;
// following variables needed for update country
let countryId = null;
let sourceOptions = ["Direct", "Associate Partner"];

const Option = Select.Option;
const FormItem = Form.Item;

const typeofDegree = {
  Diploma: [
    { key: "Diploma Of Engineering", value: "Diploma Of Engineering" },
    { key: "Diploma Of Management", value: "Diploma Of Management" },
  ],
  "Bachelor Degree": [
    { key: "Bachelor of Agriculture", value: "Bachelor of Agriculture" },
    { key: "Bachelor of Arts", value: "Bachelor of Arts" },
    {
      key: "Bachelor of Ayurvedic Medicine & Surgery - BAMS",
      value: "Bachelor of Ayurvedic Medicine & Surgery - BAMS",
    },
    {
      key: "Bachelor of Business Administration",
      value: "Bachelor of Business Administration",
    },
    { key: "Bachelor of Commerce", value: "Bachelor of Commerce" },
    {
      key: "Bachelor of Computer Applications",
      value: "Bachelor of Computer Applications",
    },
    {
      key: "Bachelor of Computer Science",
      value: "Bachelor of Computer Science",
    },
    {
      key: "Bachelor of Dental Surgery - BDS",
      value: "Bachelor of Dental Surgery - BDS",
    },

    { key: "Bachelor of Design", value: "Bachelor of Design" },
    { key: "Bachelor of Education", value: "Bachelor of Education" },
    { key: "Bachelor of Engineering", value: "Bachelor of Engineering" },
    { key: "Bachelor of Fine Arts", value: "Bachelor of Fine Arts" },
    { key: "Bachelor of Home Science", value: "Bachelor of Home Science" },

    {
      key: "Bachelor of Homeopathic Medicine and Surgery - BHMS",
      value: "Bachelor of Homeopathic Medicine and Surgery - BHMS",
    },
    { key: "Bachelor of Laws", value: "Bachelor of Laws" },
    {
      key: "Bachelor of Mass Communications",
      value: "Bachelor of Mass Communications",
    },
    {
      key: "Bachelor of Medicine and Bachelor of Surgery (MBBS)",
      value: "Bachelor of Medicine and Bachelor of Surgery (MBBS)",
    },
    { key: "Bachelor of Nursing", value: "Bachelor of Nursing" },
    { key: "Bachelor of Pharmacy", value: "Bachelor of Pharmacy" },
    { key: "Bachelor of Physiotherapy", value: "Bachelor of Physiotherapy" },
    { key: "Bachelor of Science", value: "Bachelor of Science" },
    { key: "Bachelor of Social Work", value: "Bachelor of Social Work" },
    { key: "Bachelor of Technology", value: "Bachelor of Technology" },
    {
      key: "Bachelor of Veterinary Science & Animal Husbandry",
      value: "Bachelor of Veterinary Science & Animal Husbandry",
    },
    { key: "Doctor of Medicine", value: "Doctor of Medicine" },
    {
      key: "Doctor of Medicine in Homoeopathy",
      value: "Doctor of Medicine in Homoeopathy",
    },
    { key: "Doctor of Pharmacy", value: "Doctor of Pharmacy" },
    { key: "Doctorate of Medicine", value: "Doctorate of Medicine" },
    {
      key: "General Nursing & Midwifery (GNM)",
      value: "General Nursing & Midwifery (GNM)",
    },
    { key: "Bachelor of Journalism", value: "Bachelor of Journalism" },
    { key: "ITI", value: "ITI" },
    { key: "Other", value: "Other" },
  ],
  "Post Graduation": [
    { key: "Master of Agriculture", value: "Master of Agriculture" },
    { key: "Master of Arts", value: "Master of Arts" },
    {
      key: "Master of Ayurvedic Medicine & Surgery - BAMS",
      value: "Master of Ayurvedic Medicine & Surgery - BAMS",
    },
  ],
};

@Form.create()
class Form2 extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      allUsers: [],
      sourceOptions: [],
      haveEnglishTestScore: false,
      nextYears: [],
      testType: '',
      testTypeList: [],
      testTypeArray: [],
      testTypeScore: [],
      speaking: 0,
      reading: 0,
      writing: 0,
      listening: 0,
      ieltsOverallScore: 0,
      ifApplicantHasEmail: null,
      applicantSufferMedicalCondition: false,
      havePassport: null,
      sameAsPeramanentAddress: false,
      haveBackgroundInformation: null,
    };
  }

  handleSubmitTab2 = (e) => {

    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        if (this.props.form2Fields.counsellorId !== valData.counsellorId) {
          this.props.handleSubmitTab2(valData);
        } else {
          const { oldCounsellorId, ...rest } = valData;
          this.props.handleSubmitTab2(rest);
        }
        this.props.form.setFieldsValue({ oldCounsellorId: undefined });
      }
    });
  };


  getAllTestTypes = async () => {
    let response = await Request.getAllTestTypes({
      results: 1000,
      count: 1000
    });
    if (response && response.data) {
      let testTypeList = [];
      let testTypeArray = [];
      response.data.map((testTypeData) => {
        testTypeList.push(testTypeData.testType)
        if (testTypeArray[testTypeData.testType] == undefined) {
          testTypeArray[testTypeData.testType] = {};
        }
        testTypeArray[testTypeData.testType] = testTypeData;
      })
      this.setState({
        testTypeList: testTypeList,
        testTypeArray: testTypeArray
      });
    }
  }
  getNextFiveYears = () => {
    let years = []
    for (let i = 0; i <= 5; i++) {
      let year = new Date().getFullYear() + i
      years.push(year.toString())
    }
    this.setState({ nextYears: years })
  }

  async componentDidMount() {
    this.getNextFiveYears();
    await this.getAllTestTypes();
    const { dispatch, form, form2Fields, allUsers } = this.props;
    this.setState({
      allUsers: allUsers,
    });
    setTimeout(() => {
      let completeData = form2Fields;
      let testTypeObject = this.state.testTypeArray[completeData.testType] != undefined ? this.state.testTypeArray[completeData.testType] : {};
      let testTypeScore = [];
      if (testTypeObject.endNumber) {
        for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
          testTypeScore.push(index + '');
        }
      }
      if (completeData.haveEnglishTestScore === "Yes") {
        this.setState({ haveEnglishTestScore: true })
      }
      this.setState({ testTypeScore, testType: completeData.testType });
      form.setFieldsValue({
        testType: completeData.testType,
        ieltsOverallScore: completeData.ieltsOverallScore,
        whichYearPlanningToGo: completeData.whichYearPlanningToGo,
        haveEnglishTestScore: completeData.haveEnglishTestScore,
        leadToIeltsCenter: completeData.leadToIeltsCenter,
        smsToStudent: completeData.smsToStudent,
        mailToStudent: completeData.mailToStudent,
        enqType: completeData.enqType,
        counsellorId: completeData.counsellorId,
        reading: completeData && completeData.reading,
        writing: completeData && completeData.writing,
        speaking: completeData && completeData.speaking,
        listening: completeData && completeData.listening,
      });
    }, 1000);
  }

  calculateOverAll = () => {
    let totalSum = 0;
    let { listening, writing, reading, speaking } = this.state;
    if (listening > 0) {
      totalSum += parseFloat(listening);
    }
    if (writing > 0) {
      totalSum += parseFloat(writing);
    }
    if (reading > 0) {
      totalSum += parseFloat(reading);
    }
    if (speaking > 0) {
      totalSum += parseFloat(speaking);
    }
    let ieltsOverallScore = 0;
    if (totalSum >= 11) {
      let data = 0;
      totalSum = Math.floor(totalSum);
      if (totalSum % 2 != 0) {
        data = totalSum + 1;
      } else {
        data = totalSum;
      }
      ieltsOverallScore = parseFloat(data / 4).toFixed(1);
    }
    this.setState({ ieltsOverallScore });
    this.props.form.setFieldsValue({ ieltsOverallScore });
  }

  render() {
    let { testTypeScore, testTypeList, testTypeArray } = this.state;
    const inputSchema2 = {
      fields: [
        {
          label: "Year Planning To Go",
          key: "whichYearPlanningToGo",
          prefixComp: <h3>Study AbroadInformation</h3>,
          type: 'select',
          options: this.state.nextYears,
          onChange: v => {
            this.props.form.setFieldsValue({ whichYearPlanningToGo: v })
          }
        },
        {
          label: 'Do you have an English test score?',
          key: 'haveEnglishTestScore',
          type: 'select',
          options: ["Yes", "Preparing", "Will Plan Soon"],
          onChange: v => {
            if (v === "Yes") {
              this.setState({ haveEnglishTestScore: true });
            } else {
              this.setState({ haveEnglishTestScore: false });
            }
            this.props.form.setFieldsValue({
              haveEnglishTestScore: v
            })
          }
        },
        {
          label: "Select Test Type",
          key: "testType",
          type: "select",
          options: testTypeList,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            let testTypeObject = testTypeArray[v] != undefined ? testTypeArray[v] : {};
            let testTypeScore = [];
            if (testTypeObject.endNumber) {
              for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
                testTypeScore.push(index + '');
              }
            }
            this.setState({ testType: v, testTypeScore });
            this.props.form.setFieldsValue({ testType: v });
          },
        },
        {
          label: "Speaking Score",
          key: "speaking",
          type: "select",
          showSearch: true,
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ speaking: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ speaking: v });
          },
        },
        {
          label: "Listening Score",
          key: "listening",
          type: "select",
          showSearch: true,
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ listening: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ listening: v });
          },
        },
        {
          label: "Writing Score",
          key: "writing",
          type: "select",
          showSearch: true,
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ writing: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ writing: v });
          },
        },
        {
          label: "Reading Score",
          key: "reading",
          type: "select",
          showSearch: true,
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.setState({ reading: v }, () => {
              // this.calculateOverAll();
            });
            this.props.form.setFieldsValue({ reading: v });
          },
        },
        {
          label: "Overall Score",
          key: "ieltsOverallScore",
          type: "select",
          showSearch: true,
          options: testTypeScore,
          disabled: !this.state.testType,
          hidden: (this.state.haveEnglishTestScore == false),
          required: (this.state.haveEnglishTestScore == true),
          onChange: (v) => {
            this.props.form.setFieldsValue({ ieltsOverallScore: v });
          },
        },
        // {
        //   label: "Send lead to IELTS center",
        //   key: "leadToIeltsCenter",
        //   type: "select",
        //   options: ["No", "Yes"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({ leadToIeltsCenter: v });
        //   },
        // },
        // {
        //   label: "Send Welcome SMS to student",
        //   key: "smsToStudent",
        //   type: "select",
        //   options: ["No", "Yes"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({ smsToStudent: v });
        //   },
        // },
        // {
        //   label: "Send Welcome E-Mail to student",
        //   key: "mailToStudent",
        //   type: "select",
        //   options: ["No", "Yes"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({ mailToStudent: v });
        //   },
        // },
        {
          label: "Study Level",
          key: "enqType",
          type: "select",
          required: true,
          options: ["Under Graduate", "Post Graduate", "Schooling"],
          onChange: (v) => {
            this.props.form.setFieldsValue({ enqType: v });
          },
        },
        {
          label: "OldCounsellor",
          key: "oldCounsellorId",
          itemStyle: {
            display: 'none',
          }
        },
        {
          label: "Counsellor 1",
          key: "counsellorId",
          type: "select",
          showSearch: true,
          required: true,
          allowClear: true,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.name,
          disabled: !rightAuth.checkRights("changeOperationalCounsellor.view"),
          options: this.state.allUsers ? this.state.allUsers : {},
          onChange: (v) => {
            this.props.form.setFieldsValue({ oldCounsellorId: this.props.form.getFieldValue("counsellorId") });
            this.props.form.setFieldsValue({ counsellorId: v });
          },
        },
        {
          label: "Counsellor 2",
          key: "subCounsellorId",
          mode: 'multiple',
          type: "select",
          showSearch: true,
          allowClear: true,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) => x.name,
          disabled: !rightAuth.checkRights("assignStudentToCounsellor.view"),
          options: this.state.allUsers ? this.state.allUsers : {},
          onChange: (v) => {
            this.props.form.setFieldsValue({ subCounsellorId: v });
          },
        },
      ],
    };
    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;
    const { allow } = this.state;

    return (
      <Form
        onSubmit={this.handleSubmitTab2}
        style={{ marginTop: 8 }}
        className={style.formCls}
        ref={this.formRef}
      >
        <div>
          <Row>
            <Col span={14} style={{ backgroundColor: "white", width: "100%" }}>
              <GetAllFormFields
                apiurl={LAPI_URL}
                inputSchema={inputSchema2}
                getFieldDecorator={getFieldDecorator}
              />
            </Col>
          </Row>
        </div>
        <div>
          <Col span={5} />
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              style={{ marginBottom: 10, marginTop: 10 }}
              loading={this.props.loading}
            >
              SAVE
            </Button>
          </Col>
        </div>
      </Form>
    );
  }
}

@Form.create()
class Inquiry extends PureComponent {
  callbackForHandleSubmitTab2 = async (valData) => {
    valData.atLevel = "Front Desk";
    valData.tab = "tab2";
    const { dispatch, form } = this.props;
    dispatch(showLoader());
    let x = await Request.updateInquiry({
      valData,
      _id: this.state.inquiryId,
    });

    dispatch(hideLoader());
    if (!x.error) {
      notification.success({
        message: "Inquiry Abroad Information Update Successfully",
      });
      if (!this.state.inquiryId) {
        this.setState({
          totalPreference: [],
          list: [],
        });
      }
      window.location.href = '/desk/operation-manager-desk';
    } else {
      notification.error({
        message: "Error Saving",
        description: x.msg,
      });
    }
  };
  calculateGap = async () => {
    let gapTotal = null;
    let totalGapInMonths = 0
    let totalGapInYears = 0
    let { list, totalData1 } = this.state;
    let currentDate = moment();
    if (list && list.length > 0 && !totalData1.length) {
      list.sort((left, right) => {
        return moment.utc(left.from, "MM-YYYY").diff(moment.utc(right.from, "MM-YYYY"))
      });
      let lastQualificationEndDate = moment(list[list.length - 1].to, "MM-YYYY").endOf('month');
      let checkDiffInMonths = currentDate.diff(lastQualificationEndDate, 'months') % 12;
      let checkDiffInYears = currentDate.diff(lastQualificationEndDate, 'years');
      totalGapInYears += checkDiffInYears
      totalGapInMonths += checkDiffInMonths
    } else if (totalData1 && totalData1.length) {
      let jobList = _.clone(totalData1)
      jobList.sort((left, right) => {
        return moment.utc(left.from, "MM-YYYY").diff(moment.utc(right.from, "MM-YYYY"))
      });
      let lastJobEndDate = moment(jobList[jobList.length - 1].to, "MM-YYYY").endOf('month');
      let checkDiffInMonths = currentDate.diff(lastJobEndDate, 'months') % 12;
      let checkDiffInYears = currentDate.diff(lastJobEndDate, 'years');
      totalGapInYears += checkDiffInYears
      totalGapInMonths += checkDiffInMonths
    }

    if (totalGapInMonths > 11) {
      let getYearFromMonths = moment.duration(totalGapInMonths, 'months').asYears()
      totalGapInYears = totalGapInYears + getYearFromMonths
      totalGapInMonths = totalGapInMonths % 12
    }
    gapTotal = totalGapInYears > 0 || totalGapInMonths > 0 ? `${totalGapInYears > 0 ? totalGapInYears : ""} ${totalGapInYears > 0 ? totalGapInYears > 1 ? "Years" : "Year" : ""} ${totalGapInMonths > 0 ? totalGapInMonths : ""} ${totalGapInMonths > 0 ? totalGapInMonths > 1 ? "Months" : "Month" : ""}` : "No Gap"
    this.setState({ gapTotal })
  }
  getAllTestTypes = async () => {
    let response = await Request.getAllTestTypes({
      results: 1000,
      count: 1000
    });
    if (response && response.data) {
      let testTypeList = [];
      let testTypeArray = [];
      response.data.map((testTypeData) => {
        testTypeList.push(testTypeData.testType)
        if (testTypeArray[testTypeData.testType] == undefined) {
          testTypeArray[testTypeData.testType] = {};
        }
        testTypeArray[testTypeData.testType] = testTypeData;
      })
      this.setState({
        testTypeList: testTypeList,
        testTypeArray: testTypeArray
      });
    }
  }
  callback = (key) => {
    let { completeData, twoOpened, fourOpened } = this.state;
    if (key == 2 && !twoOpened) {
      this.setState({ twoOpened: true });
      const { dispatch, form } = this.props;
      setTimeout(() => {
        let testTypeObject = this.state.testTypeArray[completeData.testType] != undefined ? this.state.testTypeArray[completeData.testType] : {};
        let testTypeScore = [];
        if (testTypeObject.endNumber) {
          for (let index = testTypeObject.startNumber; index <= testTypeObject.endNumber; index += testTypeObject.numberStep) {
            testTypeScore.push(index + '');
          }
        }
        this.setState({ testTypeScore });
        form.setFieldsValue({
          testType: completeData && completeData.testType,
          ieltsOverallScore: completeData && completeData.ieltsOverallScore,
          whichYearPlanningToGo:
            completeData && completeData.whichYearPlanningToGo,
          haveEnglishTestScore: completeData && completeData.haveEnglishTestScore,
          leadToIeltsCenter: completeData && completeData.leadToIeltsCenter,
          smsToStudent: completeData && completeData.smsToStudent,
          mailToStudent: completeData && completeData.mailToStudent,
          enqType: completeData && completeData.enqType,
          counsellorId: completeData.counsellorId
            ? completeData.counsellorId._id
            : "",
          reading:
            completeData &&
            completeData.profile &&
            completeData.profile.reading,
          writing:
            completeData &&
            completeData.profile &&
            completeData.profile.writing,
          speaking:
            completeData &&
            completeData.profile &&
            completeData.profile.speaking,
          listening:
            completeData &&
            completeData.profile &&
            completeData.profile.listening,
        });
      }, 300);
    }
    if (key == 3) {
      if (completeData && completeData.totalPreference) {
        let x = [];
        Each(
          completeData.totalPreference,
          async (item, done) => {
            let country = await Request.getCountry(item.countryId);
            let city = "";
            if (item.cityId != "") {
              city = await Request.getCity(item.cityId);
            }

            let a = {};
            a.country = country.doc;
            a.city = city.doc;
            x.push(a);
            done();
          },
          () => {
            if (!this.state.edited) {
              this.setState({ totalPreference: x });
            }
          }
        );
      }
    }
    if (key == 4 && !fourOpened) {
      this.setState({ fourOpened: true });

      if (completeData && completeData.gapTotal) {
        this.setState({ gapTotal: completeData.gapTotal })
      }

      if (
        completeData &&
        completeData.profile &&
        completeData.profile.newQualification
      ) {
        _.each(completeData.profile.newQualification, (vv) => {
          vv._id = Moment().unix();
        });
      }
      if (completeData && completeData.counsellingDesk.reference) {
        let x = [];
        completeData.counsellingDesk.reference.map((item) => {
          let a = {};
          a.country = { countryName: item.country, _id: item.countryId };
          a.name = item.name;
          a.mobile = item.mobile;

          x.push(a);
        });
        completeData.counsellingDesk.reference = x;

        this.setState({ totalData: completeData.counsellingDesk.reference });
      }

      this.setState({
        list:
          completeData &&
            completeData.profile &&
            completeData.profile.newQualification
            ? completeData.profile.newQualification
            : [],
      });

      if (
        completeData &&
        completeData.profile &&
        completeData.profile.jobDetails
      ) {
        let x = [];
        completeData.profile.jobDetails.map((item) => {
          let a = {};
          a.from = item.from;
          a.to = item.to;
          a.phone = item.phone;
          a.jobTitle = item.jobTitle;
          a.company = item.company;
          a.contactPerson = item.contactPerson;
          x.push(a);
        });

        completeData.profile.jobDetails = x;
        this.setState({
          totalData1: completeData.profile.jobDetails,
        });
      }
    }
  };
  handleSubmitTab1 = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let qualification = this.state.list;
        valData.tab = "tab1";

        valData.profile = {
          passportNumber: valData.passport,
          address: valData.address,
          landline: valData.landline,
        };
        delete valData.passport;
        delete valData.address;
        delete valData.landline;

        dispatch(showLoader());

        let formData = new FormData();
        formData.append("values", JSON.stringify(valData));
        formData.append("_id", this.state.inquiryId);
        if (this.state.imageSrc) {
          formData.append("profileImage", this.state.imageSrc);
        }

        let x = await Request.updateInquiryTab1(formData, this.state.inquiryId);
        dispatch(hideLoader());
        if (!x.error) {
          notification.success({
            message: "Inquiry Basic Info Update Successfully",
          });
          if (!this.state.inquiryId) {
            this.setState({
              totalPreference: [],
              list: [],
              imageSrc: null,
              showWebCam: false,
            });
          } else {
            this.setFormValues(this.state.inquiryId);
            this.setState({
              imageSrc: null,
              showWebCam: false,
            });
          }
        } else {
          notification.error({
            message: "Error Saving",
            description: x.msg,
          });
        }
      }
    });
  };
  handleSubmitTab3 = async (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    let valData = {};
    valData.totalPreference = this.state.totalPreference;
    valData.tab = "tab3";
    if (!valData.totalPreference.length) {
      notification.error({
        message: "Please enter atleast 1 Preference.",
      });
      return;
    }

    let data = [];
    _.each(valData.totalPreference, (item) => {
      let abc = {};
      abc.country = item.country.countryName;
      abc.city =
        item.city && item.city.cityName != null ? item.city.cityName : "";
      abc.countryId = item.country._id;
      abc.cityId =
        item.city && item.city._id != null ? item.city._id : "";
      data.push(abc);
    });
    valData.totalPreference = data;
    dispatch(showLoader());
    let x = await Request.updateInquiry({
      valData,
      _id: this.state.inquiryId,
    });
    dispatch(hideLoader());
    if (!x.error) {
      notification.success({
        message: "Inquiry Preference Update Successfully",
      });
      if (!this.state.inquiryId) {
        this.setState({
          totalPreference: [],
          list: [],
        });
      }

    } else {
      notification.error({
        message: "Error Saving",
        description: x.msg,
      });
    }
  };
  handleSubmitTab4 = async (e) => {
    const { dispatch, form } = this.props;
    const { totalData } = this.state;
    e.preventDefault();
    let qualification = this.state.list;
    let valData = {};
    if (!qualification.length) {
      notification.error({
        message: "Please enter atleast 1 Qualification.",
      });
      return;
    }

    let refData = [];
    _.each(totalData, (item) => {
      let abc = {};
      abc.country = item.country.countryName;
      abc.countryId = item.country._id;
      abc.name = item.name;
      abc.mobile = item.mobile;
      refData.push(abc);
    });

    qualification = _.map(qualification, (item) => {
      delete item.editable;
      item._id = Moment().unix();
      return item;
    });

    valData.tab = "tab4";
    valData.reference = refData;
    valData.qualification = qualification;

    //Job information

    valData.job = this.state.totalData1;

    let jobData = [];
    _.each(valData.job, (item) => {
      let abc = {};
      abc.phone = item.phone;
      abc.from = item.from;
      abc.to = item.to;
      abc.jobTitle = item.jobTitle;
      abc.company = item.company;
      abc.contactPerson = item.contactPerson;
      jobData.push(abc);
    });
    delete valData.job;

    valData.tab = "tab5";
    valData.jobDetails = jobData;
    valData.gapTotal = this.state.gapTotal;

    dispatch(showLoader());

    let x = await Request.updateInquiry({
      valData,
      _id: this.state.inquiryId,
    });
    dispatch(hideLoader());

    if (!x.error) {
      notification.success({
        message: "Inquiry Qualification/Job Update Successfully",
      });
      if (!this.state.inquiryId) {
        this.setState({
          totalPreference: [],
          list: [],
          totalData: [],
        });
      }
    } else {
      notification.error({
        message: "Error Saving",
        description: x.msg,
      });
    }
  };

  setFormValues = async (inquiryId) => {
    const { dispatch, form } = this.props;
    try {
      this.setState({ inquiryId: inquiryId });
      let { doc, allow } = await Request.getInquiry(inquiryId);
      if (doc.permanentAddressCountry || doc.currentAddressCountry) {
        this.loadStates(doc.permanentAddressCountry || doc.currentAddressCountry);
      }
      if (doc.permanentAddressState || doc.currentAddressState) {
        this.loadCitiesByState(doc.permanentAddressState || doc.currentAddressState);
      }
      if (doc && allow) {
        if (doc.location == "Associate Partner") {
          this.loadAssociativePartners("Associate Partner");
          this.setState({ locationSet: true });
        }
        this.setState({ haveBackgroundInformation: (doc && doc.haveBackgroundInformation === "Yes" ? true : doc.haveBackgroundInformation === true ? true : false) }, () => {
          this.setState({ applicantConvictedCriminalOffence: ((doc.haveBackgroundInformation === "Yes" || doc.haveBackgroundInformation === true) && doc.applicantConvictedCriminalOffence == "Yes" ? true : false) }, () => {
            form.setFieldsValue({ applicantCriminalOffence: doc && doc.applicantCriminalOffence, })
          });
          this.setState({ applicantSufferMedicalCondition: ((doc.haveBackgroundInformation === "Yes" || doc.haveBackgroundInformation === true) && doc.applicantSufferMedicalCondition == "Yes" ? true : false) }, () => {
            form.setFieldsValue({ applicantMedicalCondition: doc && doc.applicantMedicalCondition })
          })
        })
        this.setState({ ifApplicantHasEmail: (doc.ifApplicantHasEmail === "Yes" ? true : false) });

        this.setState({ havePassport: (doc && doc.havePassport === "Yes" ? true : doc.havePassport === true ? true : false) }, () => {
          form.setFieldsValue({ passport: doc && doc.passport })
        })
        this.setState({ sameAsPeramanentAddress: doc && doc.sameAsPeramanentAddress }, () => {
          form.setFieldsValue({ sameAsPeramanentAddress: doc && doc.sameAsPeramanentAddress })
        });
        this.setState({ showParentField: (doc.accompaniedByParentGuardian == 'Yes' ? true : false) });
        this.setState({
          applicantCitizenMoreCountrySwitch: doc.applicantCitizenMoreCountrySwitch,
          ifWhatsAppNumberIsDifferentSwitch: doc.ifWhatsAppNumberIsDifferentSwitch,
          applicantLivingStudyingAnyOtherCountrySwitch: doc.applicantLivingStudyingAnyOtherCountrySwitch,
          applicantAppliedAnyTypeImmigrationCountryIdSwitch: doc.applicantAppliedAnyTypeImmigrationCountryIdSwitch,
          applicantVisaRefusalCountryIdSwitch: doc.applicantVisaRefusalCountryIdSwitch,
        });
        this.setState({ completeData: doc }, () => {
          form.setFieldsValue({
            studentName: doc.studentName,
            selectInquiryType: doc.selectInquiryType,
            profilePic: doc.profilePic,
            gender: doc.gender,
            ifApplicantHasEmail: doc.ifApplicantHasEmail,
            maritalStatus: doc.maritalStatus,
            address2: doc.address2,
            havePassport: doc && doc.havePassport === "Yes" ? true : doc.havePassport === true ? true : false,
            sameAsPeramanentAddress: doc && doc.sameAsPeramanentAddress,
            permanentAddressCountry: doc.permanentAddressCountry ? doc.permanentAddressCountry : null,
            currentAddressCountry: doc.currentAddressCountry ? doc.currentAddressCountry : null,
            permanentAddressState: doc.permanentAddressState ? doc.permanentAddressState : null,
            currentAddressState: doc.currentAddressState ? doc.currentAddressState : null,
            permanentAddressCity: doc.permanentAddressCity ? doc.permanentAddressCity : null,
            currentAddressCity: doc.currentAddressCity ? doc.currentAddressCity : null,
            haveBackgroundInformation: doc && doc.haveBackgroundInformation,
            addressCountryId: doc.addressCountryId,
            state: doc.state,
            currentAddress: doc && doc.currentAddress,
            city: doc.city,
            pincode: doc.pincode,
            issueDate: Moment(doc.issueDate),
            expiryDate: Moment(doc.expiryDate),
            issueCountryId: doc.issueCountryId,
            countryOfBirth: doc.countryOfBirth,
            cityOfBirth: doc.cityOfBirth,
            nationality: doc.nationality,
            citizenship: doc.citizenship,
            contactPreferredTime: doc && doc.contactPreferredTime,
            howToContact: doc && doc.howToContact,
            emergencyCountryCode: doc && doc.emergencyCountryCode,
            applicantCitizenMoreCountrySwitch: doc.applicantCitizenMoreCountrySwitch,
            ifWhatsAppNumberIsDifferentSwitch: doc.ifWhatsAppNumberIsDifferentSwitch,
            applicantLivingStudyingAnyOtherCountrySwitch: doc.applicantLivingStudyingAnyOtherCountrySwitch,
            applicantAppliedAnyTypeImmigrationCountryIdSwitch: doc.applicantAppliedAnyTypeImmigrationCountryIdSwitch,
            applicantVisaRefusalCountryIdSwitch: doc.applicantVisaRefusalCountryIdSwitch,

            applicantCitizenMoreCountry: doc.applicantCitizenMoreCountry,
            applicantLivingStudyingAnyOtherCountry: doc.applicantLivingStudyingAnyOtherCountry,
            applicantAppliedAnyTypeImmigrationCountryId: doc.applicantAppliedAnyTypeImmigrationCountryId,
            applicantSufferMedicalCondition: doc.applicantSufferMedicalCondition,
            applicantVisaRefusalCountryId: doc.applicantVisaRefusalCountryId,
            applicantConvictedCriminalOffence: doc.applicantConvictedCriminalOffence,
            emergencyName: doc.emergencyName,
            emergencyEmail: doc.emergencyEmail,
            emergencyRelationShip: doc.emergencyRelationShip,

            mode: doc.mode,
            accompaniedByParentGuardian: doc.accompaniedByParentGuardian,
            parentGuardianName: doc.parentGuardianName,
            countryCode: doc.countryCode,
            location: doc.location,
            remarks: doc.remarks,
            associativePartnerId: doc.associativePartnerId,
            mobile: doc.mobile ? parseInt(doc.mobile) : null,
            parentMobile: doc.parentMobile ? parseInt(doc.parentMobile) : null,
            landline: doc.profile.landline
              ? parseInt(doc.profile.landline)
              : null,
            emailId: doc.emailId,
            watsupp: doc.watsupp ? parseInt(doc.watsupp) : null,
            facebookEmail: doc.facebookEmail,
            dateOfBirth: Moment(doc.dateOfBirth),
            address: doc.profile.address,
            passport: doc && doc.profile ? doc.profile.passportNumber : "",
          });
        });
      } else {
        this.setState({ allow: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  loadStates = async id => {
    Request.loadStates(id)
      .then(daa => {
        daa.result = daa.result.reduce((total, val) => {
          total.push({
            id: val._id,
            _id: val._id,
            display: val.stateName
          })
          return total
        }, [])
        this.setState({ statesData: daa.result })
      })
      .catch(err => {
      })
  }
  loadCitiesByState = async id => {
    Request.loadCities(id)
      .then(data => {
        data.result = data.result.reduce((total, val) => {
          total.push({
            id: val._id,
            _id: val.cityId,
            display: val.cityName
          })
          return total
        }, [])
        this.setState({ citiesData: data.result })
      })
      .catch(err => {
      })
  };

  loadDealingCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
    };
    Request.getDealingCountries({ ...params }).then((resp) => {
      let dealingPhoneCodes = [];
      let dealingCountryPhoneCodes = [];
      let dealingCountryFieldArr = [];
      resp.data = resp.data.reduce((temp, vv) => {
        dealingCountryFieldArr.push({ _id: vv._id, display: vv.countryName });
        if (vv.countryPhoneCode) {
          dealingCountryPhoneCodes[vv._id] = vv.countryPhoneCode;
          dealingPhoneCodes.push(vv.countryPhoneCode);
        }
        temp.push({ ...vv });
        return temp;
      }, []);
      this.setState({ dealingCountryArr: resp.data, dealingCountryFieldArr: dealingCountryFieldArr, dealingPhoneCodes: dealingPhoneCodes, dealingCountryPhoneCodes: dealingCountryPhoneCodes });
    })
  }

  loadCountries = () => {
    let params = {
      results: 100,
      sortField: "countryName",
      sortOrder: "ascend",
      businessId: activeUser && activeUser.businessId
    };
    Request.getCountriesWithoutAuth({ ...params })
      .then((resp) => {
        let countryFieldArr = [];
        let phoneCodes = [];
        let countryPhoneCodes = [];
        resp.data = resp.data.reduce((temp, vv) => {
          countryFieldArr.push({ _id: vv._id, display: vv.countryName });
          if (vv.countryPhoneCode) {
            countryPhoneCodes[vv._id] = vv.countryPhoneCode;
            phoneCodes.push(vv.countryPhoneCode);
          }
          temp.push({ ...vv });
          return temp;
        }, []);
        this.setState({ countryArr: resp.data, countryFieldArr: countryFieldArr, countryPhoneCodes, phoneCodes });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  loadCities = (countryId) => {
    return new Promise(async (resolve) => {
      let data = await Request.loadCitiesByCountry(countryId);
      this.setState({ cityArr: data.result });
    });
  };
  loadAssociativePartners = (source) => {
    if (source == "Associate Partner") {
      return new Promise(async (resolve) => {
        let params = {
          branchAssociatePartner: "Associate Partner",
          sortField: "branchName",
          results: 1000,
        };

        let data = await Request.loadSimpleBranch({ ...params });
        this.props.dispatch({
          type: "SET_ALL_CP",
          data: data.data,
        });

        this.setState({
          locationSet: true,
        });
      });
    } else {
      this.setState({
        locationSet: false,
      });
    }
  };
  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };
  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild });
  };

  // loadCountries = () => {
  //   let params = {sortField: 'countryName', sortOrder: 'ascend', businessId:activeUser && activeUser.businessId}
  //   Request.getCountriesWithoutAuth({...params})
  //     .then(resp => {
  //       resp.data = resp.data.reduce((temp, vv) => {
  //         temp.push({_id: vv.countryName, display: vv.countryName})
  //         return temp
  //       }, [])
  //       this.setState({countryArr: resp.data})
  //     })
  //     .catch(err => {
  //       console.log(err)
  //     })
  setRef = (webcam) => {
    this.webcam = webcam;
  };

  capture = () => {
    const imageSrc = this.webcam.getScreenshot();
    this.setState({
      imageSrc: imageSrc,
    });
  };
  onSave = (index) => {
    const { form } = this.props;
    let x = form.getFieldsValue([
      "qualification",
      "percentage",
      "maths",
      "english",
      "stream",
      "major",
      "passingYear",
      "backlogs",
      "degreeType",
    ]);
    let editedData = [...this.state.list];
    editedData[index] = { ...x };
    this.setState({ list: editedData }, () => {
    });
  };

  getAllSource = async () => {
    let response = await Request.getSourceDetails({
      results: 1000,
      count: 1000
    })
    let sourceObject = [];
    response.data && response.data.map((source) => {
      sourceObject.push(source.sourceName)
    })
    this.setState({ modeArr: sourceObject })
  }
  deleteImage = async () => {
    this.setState({ imageSrc: null })
  }


  getAllGenders = async () => {
    let response = await Request.getGenderDetails({
      results: 1000,
      count: 1000
    })
    let genderObject = [];
    response.data && response.data.map((gender) => {
      genderObject.push(gender.genderName)
    })
    this.setState({ genderArr: genderObject })
  }


  setFormTwoData() {
    let { completeData } = this.state;
    if (completeData) {
      let aaa = {
        testType: completeData && completeData.testType,
        ieltsOverallScore: completeData.ieltsOverallScore
          ? parseFloat(completeData.ieltsOverallScore)
          : null,
        whichYearPlanningToGo: completeData.whichYearPlanningToGo,
        haveEnglishTestScore: completeData.haveEnglishTestScore,
        leadToIeltsCenter: completeData.leadToIeltsCenter,
        smsToStudent: completeData.smsToStudent,
        mailToStudent: completeData.mailToStudent,
        enqType: completeData.enqType,
        counsellorId: completeData.counsellorId
          ? completeData.counsellorId._id
          : "",
        reading: completeData.profile && completeData.profile.reading,
        writing: completeData.profile && completeData.profile.writing,
        speaking: completeData.profile && completeData.profile.speaking,
        listening: completeData.profile && completeData.profile.listening,
      };
      return aaa;
    }
  }

  async componentDidMount() {
    await this.getAllSource()
    await this.getAllGenders()
    await this.getAllTestTypes();
    let localUser = JSON.parse(localStorage.getItem("user"));

    //Last userId is temporary. Need to remove later - Discuss with Naresh Sir.
    let { data: allUsers } = await Request.loadDeskUser({
      results: 10000,
      isCounsellor: true,
      active: true,
      userBranch: localUser && localUser.userBranch ? localUser.userBranch : null
    });

    this.setState({ allUsers });
    let searchParams = new URLSearchParams(this.props.search);

    let inquiryId = searchParams.get("id");
    this.setFormValues(inquiryId);

    let found = _.find(allUsers, (user) => {
      return user.userBranch._id == localUser.userBranch;
    });

    // if (found.userBranch.branchName != "Karnal") {
    //   this.setState({ sourceOptions, showOptions: true });
    // } else {
    //   this.setState({ showOptions: false });
    // }
  }

  getAllMaritalStatus = async () => {
    let response = await Request.getMaritalStatusDetails({
      results: 1000,
      count: 1000
    })
    let maritalObject = [];
    response.data && response.data.map((marital) => {
      maritalObject.push(marital.maritalStatus)
    })
    this.setState({ maritalArr: maritalObject })
  }

  constructor(props) {
    super(props);
    this.state = {
      testTypeList: [],
      testTypeArray: [],
      testTypeScore: [],
      showSave: 1,
      edited: false,
      showFiles: 0,
      completeData: null,
      refreshChild: false,
      show: true,
      countryArr: [],
      modeArr: [],
      maritalArr: [],
      genderArr: [],
      countryFieldArr: [],
      statesData: [],
      citiesData: [],
      countryPhoneCodes: [],
      phoneCodes: [],
      totalPreference: [],
      city: null,
      gapTotal: '',
      country: null,
      dealingCountryArr: [],
      dealingCountryFieldArr: [],
      dealingPhoneCodes: [],
      dealingCountryPhoneCodes: [],
      allow: true,
      showParentField: false,
      qua: [
        {
          tabTitle: "Basic Details",
          fields: [
            {
              label: "Standard",
              key: "standard",
              required: true,
              type: "select",
              options: ["STUDENT"],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  selectInquiryType: v,
                });
              },
            },
            {
              label: "Degree Type",
              key: "degreeType",
              required: true,
              type: "select",
              options: ["MASTER OF ARCHITECUTRE"],
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  selectInquiryType: v,
                });
              },
            },
            { label: "Year", key: "year", style: { width: 100 } },
            { label: "Grade ", key: "grade", style: { width: 100 } },
            { label: "Maths ", key: "maths", style: { width: 100 } },
            { label: "English ", key: "english", style: { width: 100 } },
            { label: "Backlogs", key: "backlogs", style: { width: 100 } },
            {
              label: "Major Subjects",
              key: "major",
              required: true,
              type: "select",
              options: [],
              tags: true,
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  major: v,
                });
              },
            },
            {
              label: "Stream",
              key: "stream",
              required: true,
              type: "select",
              options: [],
              tags: true,
              onChange: (v) => {
                this.props.form.setFieldsValue({
                  stream: v,
                });
              },
            },
          ],
        },
      ],
      current: 0,
      list: [],
      allUsers: [],
      userId: "",
      twoOpened: false,
      fourOpened: false,
      totalData: [],
      totalData1: [],
      imageSrc: null,
      showWebCam: false,
    };
    this.table = React.createRef();

    this.loadCountries();
    this.loadDealingCountries();
    this.getAllMaritalStatus()
  }

  render() {
    const {
      list,
      completeData,
      allow,
      profilePic,
      sourceOptions,
      showOptions,
      applicantCitizenMoreCountrySwitch,
      ifWhatsAppNumberIsDifferentSwitch,
      applicantLivingStudyingAnyOtherCountrySwitch,
      applicantAppliedAnyTypeImmigrationCountryIdSwitch,
      applicantVisaRefusalCountryIdSwitch,
      phoneCodes,
      statesData,
      citiesData,
      countryPhoneCodes,
      dealingCountryArr,
      dealingCountryFieldArr,
      dealingPhoneCodes,
      dealingCountryPhoneCodes,
    } = this.state;

    const firstTab = {
      fields: [
        // {
        //   label: "Select Inquiry Type:",
        //   key: "selectInquiryType",
        //   required: true,
        //   type: "select",
        //   options: ["STUDENT"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({
        //       selectInquiryType: v,
        //     });
        //   },
        // },
        {
          label: "Upload Image",
          prefixComp: (
            <div className={style.editWebCamBtn}>
              <div className={style.webCamInner}>
                {" "}
                Or &nbsp;&nbsp;
                <Button onClick={() => this.setState({ showWebCam: true })}>
                  Capture Image
                </Button>
                {this.state.imageSrc ? (
                  <div style={{ display: "flex" }}>
                    <img src={this.state.imageSrc} className={style.smallImg} />
                    <p className={style.deleteImg} onClick={this.deleteImage}>{<Icon type="delete" />}</p>
                  </div>
                ) : null}
              </div>
            </div>
          ),
          key: "profilePic",
          type: "file",
          limit: 1,
          defaultFileList: [],
        },
      ],
    };
    const inputSchma = {
      fields: [
        {
          label: "Full Name as per passport ",
          key: "studentName",
          required: true,
        },
        {
          label: "Date Of Birth",
          key: "dateOfBirth",
          type: "date",
          required: true,
        },
        {
          label: "Gender",
          key: "gender",
          required: true,
          type: "select",
          options: this.state.genderArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              gender: v,
            });
          },
        },
        {
          label: "Marital Status",
          key: "maritalStatus",
          required: true,
          type: "select",
          defaultValue: "nfjw",
          options: this.state.maritalArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              maritalStatus: v,
            });
          },
        },
        {
          label: "How you come to know about us",
          key: "mode",
          type: "select",
          required: true,
          options: this.state.modeArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({ mode: v });
          },
        },
        {
          label: 'How do you want us to contact?',
          key: 'howToContact',
          type: 'select',
          showSearch: true,
          options: ["Direct Mobile Call", "Direct Whatsapp Call", "Only Whatsapp Message", "Only Email"],
          onChange: v => {
            this.props.form.setFieldsValue({ howToContact: v });
          }
        },
        {
          label: 'Preferred time to contact you?',
          key: 'contactPreferredTime',
          type: 'select',
          showSearch: true,
          options: ["Anytime", "10AM to 12PM", "12PM to 2PM", "2PM to 4PM", "4PM to 6PM", "After 6PM"],
          onChange: v => {
            this.props.form.setFieldsValue({ contactPreferredTime: v });
          }
        },
        {
          key: "accompaniedByParentGuardian",
          label: "Accompanied by Parent/Guardian",
          required: true,
          type: "select",
          options: ["Yes", "No"],
          onChange: (v) => {
            this.setState({ showParentField: (v == 'Yes' ? true : false) })
            this.props.form.setFieldsValue({
              accompaniedByParentGuardian: v,
            });
          },
        },
        {
          label: "Parent/Guardian Name ",
          key: "parentGuardianName",
          required: (this.state.showParentField === true),
          hidden: (this.state.showParentField === false)
        },
        {
          label: "Reference",
          key: "location",
          type: showOptions ? "select" : null,
          options: sourceOptions,
          disabled: true,
          onChange: (v) => {
            this.props.form.setFieldsValue({ location: v });
            this.loadAssociativePartners(v);
          },
        },
        {
          label: "Users",
          key: "associativePartnerId",
          type: "select",
          hidden: !this.state.locationSet,
          keyAccessor: (x) => x._id,
          valueAccessor: (x) =>
            `${x.branchName} ${x.branchHeadPhone ? "(" + x.branchHeadPhone + ")" : ""
            }`,
          customProps: {
            style: {
              width: "calc(100% - 40px)",
            },
          },
          rightComp: (
            <Button
              style={{ marginLeft: "3px" }}
              type="primary"
              onClick={() => {
                this.showDrawer();
              }}
            >
              {<Icon type="plus" />}
            </Button>
          ),
          options: this.props.allChannelPartners,
          onChange: (user) => {
            this.setState({ associativePartnerId: user });

            this.props.form.setFieldsValue({ associativePartnerId: user });
          },
        },
      ],
    };
    const firstTabExtra = {
      fields: [
        {
          label: "Country",
          key: "addressCountryId",
          type: "select",
          required: true,
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.dealingCountryFieldArr,
          onChange: (v) => {
            if (countryPhoneCodes) {
              let phoneCodeValue = (countryPhoneCodes[v] != undefined ? countryPhoneCodes[v] : '');
              this.props.form.setFieldsValue({ countryCode: phoneCodeValue });
            }
            this.props.form.setFieldsValue({
              addressCountryId: v,
            });
          },
        },
        {
          label: "Country Code",
          key: "countryCode",
          type: "select",
          required: true,
          showSearch: true,
          options: dealingPhoneCodes,
          onChange: (v) => {
            this.props.form.setFieldsValue({ countryCode: v });
          },
        },
        {
          label: "Mobile Number",
          key: "mobile",
          type: "number",
          required: true,
          style: { width: 150 },
          parser: (value) => value.substring(0, 10)
        },
        {
          label: "Parents Number",
          key: "parentMobile",
          type: "number",
          required: true,
          style: { width: 150 },
          parser: (value) => value.substring(0, 10)
        },
        {
          label: 'WhatsApp same as above?',
          key: 'ifWhatsAppNumberIsDifferentSwitch',
          type: 'switch',
          onChange: v => {
            this.setState({ ifWhatsAppNumberIsDifferentSwitch: v });
            this.props.form.setFieldsValue({
              ifWhatsAppNumberIsDifferentSwitch: v
            })
          }
        },
        {
          label: "Whatsapp Number",
          hidden: (this.state.ifWhatsAppNumberIsDifferentSwitch == true),
          required: (this.state.ifWhatsAppNumberIsDifferentSwitch == false),
          key: "watsupp",
          type: "number",
          style: { width: 150 },
        },
        {
          label: 'Has Email?',
          key: 'ifApplicantHasEmail',
          type: 'select',
          options: ["Yes", "No", "Asked But Not Given"],
          defaultValue: "Yes",
          onChange: v => {
            if (v === "Yes") {
              this.setState({ ifApplicantHasEmail: true });
            } else {
              this.setState({ ifApplicantHasEmail: false });
            }
            this.props.form.setFieldsValue({
              ifApplicantHasEmail: v
            })
          }
        },
        {
          label: "Email Id ", key: "emailId", hidden: (this.state.ifApplicantHasEmail == false),
          required: (this.state.ifApplicantHasEmail == true), type: 'email'
        },
        {
          label: 'Passport No.',
          type: 'switch',
          key: 'havePassport',
          onChange: v => {
            this.props.form.setFieldsValue({ havePassport: v }, () => {
              this.setState({ havePassport: v })
            })
          }
        },
        {
          label: "Passport",
          key: "passport",
          type: "text",
          hidden: !this.state.havePassport,
          required: this.state.havePassport
        },
      ],
    };

    const permanentAddressInputSchema = {
      fields: [
        {
          label: 'Permanent Address',
          key: 'address',
          type: 'textArea',
          required: true
        },
        {
          label: 'Country',
          key: 'permanentAddressCountry',
          type: 'select',
          options: this.state.dealingCountryFieldArr,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ permanentAddressCountry: v }, () => {
              this.loadStates(v);
            })
          }
        },
        {
          label: 'State',
          key: 'permanentAddressState',
          type: 'select',
          options: this.state.statesData,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ permanentAddressState: v }, () => {
              this.loadCitiesByState(v);
            })
          }
        },
        {
          label: 'City',
          key: 'permanentAddressCity',
          type: 'select',
          options: this.state.citiesData,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ permanentAddressCity: v })
          }
        }
      ]
    }
    const currentAddressInputSchema = {
      fields: [
        {
          label: 'Same as Permanent Address',
          key: 'sameAsPeramanentAddress',
          type: 'checkbox',
          onClick: v => {
            this.setState({ sameAsPeramanentAddress: v.target.checked })
          }
        },
        {
          label: 'Current Address',
          key: 'currentAddress',
          type: 'textArea',
          hidden: this.state.sameAsPeramanentAddress
        },
        {
          label: 'Country',
          key: 'currentAddressCountry',
          type: 'select',
          options: this.state.dealingCountryFieldArr,
          hidden: this.state.sameAsPeramanentAddress,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ currentAddressCountry: v }, () => {
              this.loadStates(v);
            })
          }
        },
        {
          label: 'State',
          key: 'currentAddressState',
          type: 'select',
          options: this.state.statesData,
          hidden: this.state.sameAsPeramanentAddress,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ currentAddressState: v }, () => {
              this.loadCitiesByState(v);
            })
          }
        },
        {
          label: 'City',
          key: 'currentAddressCity',
          type: 'select',
          options: this.state.citiesData,
          hidden: this.state.sameAsPeramanentAddress,
          showSearch: true,
          onChange: v => {
            this.props.form.setFieldsValue({ currentAddressCity: v })
          }
        }
      ]
    }

    const addressInputSchema = {
      fields: [
        {
          label: "Permanent Address",
          key: "address",
          type: "textArea",
          required: true,
        },
        {
          label: "Temporary Address",
          key: "address2",
          type: "textArea",
        },
        {
          label: "State",
          key: "state",
          type: "text"
        },
        {
          label: "City",
          key: "city",
          type: "text"
        },
        {
          label: "Pincode",
          key: "pincode",
          type: "text"
        },
      ]
    };
    const passportInputSchema = {
      fields: [
        {
          label: "Passport",
          key: "passport",
          type: "text"
        },
        {
          label: "Issue Date",
          key: "issueDate",
          type: "date"
        },
        {
          label: "Expiry Date",
          key: "expiryDate",
          type: "date"
        },
        {
          label: "Issue Country",
          key: "issueCountryId",
          showSearch: true,
          type: "select",
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              issueCountryId: v,
            });
          },
        },
        {
          label: "Country Of Birth",
          key: "countryOfBirth",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              countryOfBirth: v,
            });
          },
        },
        {
          label: "City of birth",
          key: "cityOfBirth",
          type: "text"
        },
      ]
    };
    const nationalityInputSchema = {
      fields: [
        {
          label: "Nationality",
          key: "nationality",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              nationality: v,
            });
          },
        },
        {
          label: "Citizenship",
          key: "citizenship",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              citizenship: v,
            });
          },
        },
        {
          label: 'Is the applicant a citizen of more than one country?',
          key: 'applicantCitizenMoreCountrySwitch',
          type: 'switch',
          onChange: v => {
            this.setState({ applicantCitizenMoreCountrySwitch: v });
            this.props.form.setFieldsValue({
              applicantCitizenMoreCountrySwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantCitizenMoreCountry",
          hidden: (this.state.applicantCitizenMoreCountrySwitch == false),
          required: (this.state.applicantCitizenMoreCountrySwitch == true),
          type: "select",
          defaultValue: "nfjw",
          showSearch: true,
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantCitizenMoreCountry: v,
            });
          },
        },
        {
          label: 'Is the applicant living and studying in any other country?',
          key: 'applicantLivingStudyingAnyOtherCountrySwitch',
          type: 'switch',
          onChange: v => {
            this.setState({ applicantLivingStudyingAnyOtherCountrySwitch: v });
            this.props.form.setFieldsValue({
              applicantLivingStudyingAnyOtherCountrySwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantLivingStudyingAnyOtherCountry",
          hidden: (this.state.applicantLivingStudyingAnyOtherCountrySwitch == false),
          required: (this.state.applicantLivingStudyingAnyOtherCountrySwitch == true),
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantLivingStudyingAnyOtherCountry: v,
            });
          },
        },
      ]
    };
    const backgroundInfoInputSchema = {
      fields: [
        {
          label: 'Background Information?',
          key: 'haveBackgroundInformation',
          type: 'switch',
          onChange: v => {
            this.setState({ haveBackgroundInformation: v });
            this.props.form.setFieldsValue({ haveBackgroundInformation: v })
          }
        },
        // {
        //   label: 'Have Background Information?',
        //   key: 'haveBackgroundInformation',
        //   type: 'select',
        //   options: [{ id: "Yes", display: 'Yes' }, { id: "No", display: 'No' }],
        //   onChange: v => {
        //     this.props.form.setFieldsValue({ haveBackgroundInformation: v }, () => {
        //       this.setState({ haveBackgroundInformation: v === "Yes" ? true : false })
        //     })
        //   }
        // },
        {
          label: 'Have you ever applied for any type of immigration/PR?',
          key: 'applicantAppliedAnyTypeImmigrationCountryIdSwitch',
          type: 'switch',
          hidden: !this.state.haveBackgroundInformation,
          onChange: v => {
            this.setState({ applicantAppliedAnyTypeImmigrationCountryIdSwitch: v });
            this.props.form.setFieldsValue({
              applicantAppliedAnyTypeImmigrationCountryIdSwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantAppliedAnyTypeImmigrationCountryId",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          hidden: (this.state.applicantAppliedAnyTypeImmigrationCountryIdSwitch == false),
          required: (this.state.applicantAppliedAnyTypeImmigrationCountryIdSwitch == true),
          options: this.state.countryFieldArr,
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantAppliedAnyTypeImmigrationCountryId: v,
            });
          },
        },
        {
          label: "Does the applicant suffer from any serious medical condition?",
          key: "applicantSufferMedicalCondition",
          type: 'select',
          hidden: !this.state.haveBackgroundInformation,
          options: ['Yes', 'No'],
          onChange: v => {
            this.props.form.setFieldsValue({ applicantSufferMedicalCondition: v }, () => {
              if (v === 'Yes') {
                this.setState({ applicantSufferMedicalCondition: true })
              } else {
                this.setState({ applicantSufferMedicalCondition: false })
              }
            })
          }
        },
        {
          label: "Explain Serious Medical Condition",
          key: 'applicantMedicalCondition',
          type: 'textArea',
          required: this.state.applicantSufferMedicalCondition,
          hidden: !this.state.applicantSufferMedicalCondition
        },
        {
          label: 'Have you been refused visa from any country?',
          key: 'applicantVisaRefusalCountryIdSwitch',
          type: 'switch',
          hidden: !this.state.haveBackgroundInformation,
          onChange: v => {
            this.setState({ applicantVisaRefusalCountryIdSwitch: v });
            this.props.form.setFieldsValue({
              applicantVisaRefusalCountryIdSwitch: v
            })
          }
        },
        {
          label: "Select Country",
          key: "applicantVisaRefusalCountryId",
          type: "select",
          showSearch: true,
          defaultValue: "nfjw",
          options: this.state.countryFieldArr,
          hidden: (this.state.applicantVisaRefusalCountryIdSwitch == false),
          required: (this.state.applicantVisaRefusalCountryIdSwitch == true),
          onChange: (v) => {
            this.props.form.setFieldsValue({
              applicantVisaRefusalCountryId: v,
            });
          },
        },
        {
          label: "Has applicant ever been convicted of a criminal offence?",
          key: "applicantConvictedCriminalOffence",
          hidden: !this.state.haveBackgroundInformation,
          type: "select",
          options: ['Yes', 'No'],
          onChange: v => {
            this.props.form.setFieldsValue({ applicantConvictedCriminalOffence: v }, () => {
              if (v === "Yes") {
                this.setState({ applicantConvictedCriminalOffence: true });
              } else {
                this.setState({ applicantConvictedCriminalOffence: false })
              }
            })
          }
        },
        {
          label: 'Explain Criminal Offence',
          key: 'applicantCriminalOffence',
          type: 'textArea',
          required: this.state.applicantConvictedCriminalOffence,
          hidden: !this.state.applicantConvictedCriminalOffence
        }
      ]
    };
    const emergencyContactInputSchema = {
      fields: [
        {
          label: "Name",
          key: "emergencyName",
          type: "text"
        },
        {
          label: 'Country Code',
          key: 'emergencyCountryCode',
          type: 'select',
          options: phoneCodes,
          onChange: v => {
            this.props.form.setFieldsValue({ emergencyCountryCode: v })
          }
        },
        {
          label: "Mobile No ",
          key: "landline",
          type: "number",
          style: { width: 150 },
        },
        {
          label: "Email",
          key: "emergencyEmail",
          type: "text"
        },
        {
          label: "Relation with Applicant",
          key: "emergencyRelationShip",
          type: "text"
        }
      ]
    };

    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;

    const qualColumns = [
      {
        title: "Latest Qualification",
        key: "qualification",
        dataIndex: "qualification",
        searchTextName: "",
        filterRegex: true,
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("qualification", {
                    initialValue: record.qualification
                      ? record.qualification
                      : null,
                  })(
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      onChange={(qualification) => {
                        record.qualification = qualification;
                      }}
                    >
                      <Option value={"X"}>X</Option>
                      <Option value={"XII"}>XII</Option>
                      <Option value={"Diploma"}>Diploma</Option>
                      <Option value={"Bachelor Degree"}>Bachelor Degree</Option>
                      <Option value={"Post Graduation"}>Post Graduation</Option>
                    </Select>
                  )}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "From",
        key: "from",
        dataIndex: "from",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("from", {
                    initialValue: record.from
                      ? record.from
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "To",
        key: "to",
        dataIndex: "to",
        render: (item, record) => {
          return (
            <>

              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("to", {
                    initialValue: record.to
                      ? record.to
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Passing Year",
        key: "passingYear",
        dataIndex: "passingYear",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("passingYear", {
                    initialValue: record.passingYear
                      ? record.passingYear
                      : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Percentage ",
        key: "percentage",
        dataIndex: "percentage",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("percentage", {
                    initialValue: record.percentage ? record.percentage : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Maths ",
        key: "maths",
        dataIndex: "maths",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("maths", {
                    initialValue: record.maths ? record.maths : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "English ",
        key: "english",
        dataIndex: "english",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("english", {
                    initialValue: record.english ? record.english : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Stream ",
        key: "stream",
        dataIndex: "stream",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("stream", {
                    initialValue: record.stream ? record.stream : null,
                  })(
                    <Select
                      showSearch={true}
                      style={{ width: "100%" }}
                      dropdownMatchSelectWidth={false}
                    >
                      <Option value={"MEDICAL"}>MEDICAL</Option>
                      <Option value={"NON-MEDICAL"}>NON-MEDICAL</Option>
                      <Option value={"COMMERCE"}>COMMERCE</Option>
                      <Option value={"ARTS"}>ARTS</Option>
                    </Select>
                  )}
                </Form.Item>
              ) : (
                item && Array.isArray(item) ? item.map((ii) => <Tag>{ii}</Tag>) : item
              )}
            </>
          );
        },
      },
      {
        title: "Major Subjects",
        key: "major",
        dataIndex: "major",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("major", {
                    initialValue: record.major ? record.major : null,
                  })(
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Tags Mode"
                    />
                  )}
                </Form.Item>
              ) : (
                item && item.map((ii) => <Tag>{ii}</Tag>)
              )}
            </>
          );
        },
      },
      {
        title: "Backlogs ",
        key: "backlogs",
        dataIndex: "backlogs",
        render: (item, record) => {
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("backlogs", {
                    initialValue: record.backlogs ? record.backlogs : null,
                  })(<InputNumber />)}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Degree Type ",
        key: "degreeType",
        dataIndex: "degreeType",
        render: (item, record) => {
          let condition =
            record.qualification == "Diploma" ||
            record.qualification == "Bachelor Degree" ||
            record.qualification == "Post Graduation";
          return (
            <>
              {record.editable ? (
                <Form.Item>
                  {getFieldDecorator("degreeType", {
                    initialValue: record.degreeType ? record.degreeType : null,
                  })(
                    <Select showSearch style={{ width: "100%" }}>
                      {condition
                        ? typeofDegree[record.qualification].map(
                          (val, index) => {
                            return (
                              <Option key={index} value={val.value}>
                                {val.value}
                              </Option>
                            );
                          }
                        )
                        : []}
                    </Select>
                  )}
                </Form.Item>
              ) : (
                item
              )}
            </>
          );
        },
      },
      {
        title: "Action",
        key: "operation",
        icon: "trash",
        fixed: "right",
        render: (val, record, key) => {
          return (
            <React.Fragment>
              <Tooltip title="Delete">
                <Button
                  shape="circle"
                  onClick={() => {
                    let tt = this.state.list;
                    tt = _.reject(tt, val);
                    this.setState({ list: tt }, () => {
                      this.calculateGap()
                    });
                  }}
                  icon="delete"
                  size={"small"}
                />
              </Tooltip>
              {/* {!record.editable && (
                <Tooltip title="Edit">
                  <Button
                    shape="circle"
                    style={{ marginLeft: "5px" }}
                    onClick={() => {
                      let newData = [...this.state.list];
                      newData = _.map(newData, (item) => {
                        item.editable = false;
                        return item;
                      });
                      newData[key] = { ...record, editable: true };
                      this.setState({ list: newData });
                    }}
                    icon="edit"
                    size={"small"}
                  />
                </Tooltip>
              )} */}

              {record.editable && (
                <a
                  style={{ color: "orange", marginLeft: "5px" }}
                  onClick={() => {
                    this.onSave(key);
                  }}
                >
                  Save
                </a>
              )}
            </React.Fragment>
          );
        },
      },
    ];
    const colum = [
      {
        title: "Country",
        key: "country",
        dataIndex: "country",
        render: (item) => {
          return item.countryName;
        },
      },
      {
        title: "City",
        key: "city",
        dataIndex: "city",
        render: (item) => {
          return item && item.cityName != null ? item.cityName : "";
        },
      },
      {
        title: "Action",
        key: "operation",

        render: (val, record) => (
          <a
            onClick={() => {
              let tt = this.state.totalPreference;
              tt = _.reject(tt, val);
              this.setState({ totalPreference: tt });
            }}
          >
            Remove
          </a>
        ),
      },
    ];
    const refColumns = [
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Mobile",
        dataIndex: "mobile",
        key: "mobile",
        required: true,
      },
      {
        title: "Country",
        dataIndex: "country",
        key: "country",
        render: (item) => {
          return item.countryName;
        },
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        render: (item, record) => (
          <React.Fragment>
            <a
              onClick={() => {
                let tt = this.state.totalData;
                tt = _.reject(tt, item);
                this.setState({ totalData: tt });
              }}
            >
              Remove
            </a>
            {/*<Tooltip title="Remove Reference">*/}
            {/*<Button*/}
            {/*type="danger"*/}
            {/*shape="circle"*/}
            {/*onClick={() => {*/}
            {/*this.removeRef(item)*/}
            {/*}}*/}
            {/*icon="delete"*/}
            {/*/>*/}
            {/*</Tooltip>*/}
          </React.Fragment>
        ),
      },
    ];
    const jobColumns = [
      {
        title: "Job Title",
        dataIndex: "jobTitle",
        key: "jobTitle",
      },
      {
        title: "Company",
        dataIndex: "company",
        key: "company",
      },
      {
        title: "Contact Person",
        dataIndex: "contactPerson",
        key: "contactPerson",
      },
      {
        title: "Phone",
        dataIndex: "phone",
        key: "phone",
      },
      {
        title: "From",
        dataIndex: "from",
        key: "from",
      },
      {
        title: "To",
        dataIndex: "to",
        key: "to",
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 150,
        render: (item, record) => (
          <React.Fragment>
            <a
              onClick={() => {
                let tt = this.state.totalData1;
                tt = _.reject(tt, item);
                this.setState({ totalData1: tt }, () => {
                  this.calculateGap()
                });
              }}
            >
              Remove
            </a>
            <a
              style={{ marginLeft: "6px" }}
              onClick={() => {
                let tt = this.state.totalData1;
                tt = _.reject(tt, item);

                this.setState({
                  to: moment(record.to, "DD-MM-YYYY"),
                  from: moment(record.from, "DD-MM-YYYY"),
                  phone: record.phone,
                  jobTitle: record.jobTitle,
                  company: record.company,
                  contactPerson: record.contactPerson,
                  totalData1: tt,
                });
              }}
            >
              Edit
            </a>
          </React.Fragment>
        ),
      },
    ];

    return !allow ? (
      <Exception
        type="404"
        desc={"You Seems lost !!"}
        linkElement={Link}
        redirect={"/dashboard"}
        backText={"Go To Homepage?"}
      />
    ) : (
      <PageHeaderWrapper title={"Update Lead"}>


        {this.state.showWebCam && (
          <Drawer
            title=""
            placement="right"
            closable={true}
            onClose={() => {
              this.setState({
                showWebCam: false,
              });
            }}
            visible={this.state.showWebCam}
            width={1000}
          >
            <div>
              <h2
                style={{
                  marginLeft: "11px",
                  marginTop: "13px",
                  color: "orange",
                }}
              >
                Upload Profile Pic
              </h2>

              <Card>
                <p
                  style={{
                    padding: "10px",
                    textAlign: "justify",
                    marginLeft: "4px",
                    marginRight: "50px",
                  }}
                >
                  <div className={style.camStyle}>
                    <Row className={style.camStyleFull}>
                      <Col span={7}>
                        <Webcam
                          audio={false}
                          height={100}
                          ref={this.setRef}
                          screenshotFormat="image/jpeg"
                          width={180}
                          videoConstraints={videoConstraints}
                        />
                      </Col>

                      <Col span={7}>
                        {this.state.imageSrc ? (
                          <img src={this.state.imageSrc} />
                        ) : null}
                      </Col>

                      <Col span={10} className={style.btnGroup1}>
                        {this.state.imageSrc ? (
                          <Button
                            onClick={() => this.setState({ imageSrc: null })}
                            type="default"
                          >
                            Remove Image
                          </Button>
                        ) : null}

                        <Button onClick={this.capture} type="primary">
                          Capture Image
                        </Button>

                        <Button
                          onClick={() =>
                            this.setState({
                              showWebCam: false,
                            })
                          }
                          type="default"
                        >
                          Close
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </p>
              </Card>
            </div>
          </Drawer>
        )}

        <Tabs
          defaultActiveKey="0"
          tabPosition={"left"}
          onChange={this.callback}
        >
          <TabPane loading={!completeData} tab="Basic Info" key="1">
            <Form
              onSubmit={this.handleSubmitTab1}
              style={{ marginTop: 8 }}
              className={style.formCls}
            >
              <div className={style.tab1}>
                <Row style={{ backgroundColor: "white" }}>
                  <Col span={20}>
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={firstTab}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col style={{ textAlign: "center", margin: 8 }}>
                    <h3>Basic Information As Per Passport </h3>
                  </Col>
                </Row>
                <Row style={{ backgroundColor: "white" }}>
                  <Col span={15}>
                    <div>
                      <GetAllFormFields
                        apiurl={LAPI_URL}
                        inputSchema={inputSchma}
                        getFieldDecorator={getFieldDecorator}
                      />
                    </div>
                  </Col>
                  <Col span={9}>
                    <div>
                      <GetAllFormFields
                        apiurl={LAPI_URL}
                        inputSchema={firstTabExtra}
                        formItemLayout={{
                          labelCol: { span: 8 },
                          wrapperCol: { span: 12 },
                        }}
                        getFieldDecorator={getFieldDecorator}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <h3 style={{ paddingTop: '25px' }}>Permanent Address</h3>
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={permanentAddressInputSchema}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col>
                  <Col span={24}>
                    <h3 style={{ paddingTop: '25px' }}>Current Address</h3>
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={currentAddressInputSchema}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col>
                  <Col span={24}>
                    <h3 style={{ paddingTop: '25px' }}>Background Info</h3>
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={backgroundInfoInputSchema}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <h3 style={{ paddingTop: '25px' }}>Nationality</h3>
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={nationalityInputSchema}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col>
                  {/* <Col span={24}>
                    <h3 style={{paddingTop: '25px'}}>Passport Information</h3>
                    <GetAllFormFields
                      apiurl={API_URL}
                      inputSchema={passportInputSchema}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col> */}
                </Row>
                <Row>
                  <Col span={24}>
                    <h3 style={{ paddingTop: '25px' }}>Important Contacts / Emergency Contacts</h3>
                    <GetAllFormFields
                      apiurl={LAPI_URL}
                      inputSchema={emergencyContactInputSchema}
                      getFieldDecorator={getFieldDecorator}
                    />
                  </Col>
                </Row>
              </div>
              {!!this.state.visible && (
                <Drawer
                  title=""
                  placement="right"
                  closable={true}
                  onClose={() => {
                    this.setState({
                      visible: false,
                    });
                  }}
                  visible={this.state.visible}
                  width={1000}
                >
                  <AddBranch
                    formOnly={true}
                    afterSave={() => {
                      this.loadAssociativePartners("Associate Partner");
                    }}
                  />
                </Drawer>
              )}
              <div>
                <Col span={5} />
                <Col>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: 10, marginTop: 10 }}
                    loading={this.props.loading}
                  >
                    SAVE
                  </Button>
                </Col>
              </div>
            </Form>
          </TabPane>
          <TabPane tab="Abroad Information" key="2">
            <Form2
              allUsers={this.state.allUsers}
              form2Fields={this.setFormTwoData()}
              handleSubmitTab2={this.callbackForHandleSubmitTab2}
            />
          </TabPane>
          <TabPane tab="Preferences" key="3">
            <Form
              onSubmit={this.handleSubmitTab3}
              style={{ marginTop: 8 }}
              className={style.formCls}
            >
              <div>
                <Row gutter={16}>
                  <div>
                    <div className={"referenceItem"}>
                      <div>
                        <h4>Select Countries</h4>
                        <Select
                          placeholder="Select Country"
                          showSearch={true}
                          optionFilterProp="children"
                          value={
                            this.state.country
                              ? this.state.country._id
                              : undefined
                          }
                          onChange={(ei) => {
                            let singleCountry = _.find(
                              this.state.countryArr,
                              (item) => {
                                return item._id == ei;
                              }
                            );

                            if (singleCountry) {
                              this.loadCities(singleCountry._id);
                            }
                            this.setState({
                              country: singleCountry,
                              city: null,
                            });
                          }}
                        >
                          {this.state.countryArr.map((val, index) => {
                            return (
                              <Option key={index} value={val._id}>
                                {val.countryName}
                              </Option>
                            );
                          })}
                        </Select>
                      </div>
                      <div>
                        <h4>Select Cities</h4>
                        <Select
                          placeholder="Select City"
                          showSearch={true}
                          optionFilterProp="children"
                          value={
                            this.state.city ? this.state.city._id : undefined
                          }
                          onChange={(ei) => {
                            let singleCity = _.find(
                              this.state.cityArr,
                              (item) => {
                                return item._id == ei;
                              }
                            );
                            if (singleCity) {
                              this.loadCities(singleCity._id);
                            }
                            this.setState({ city: singleCity });
                          }}
                        >
                          {this.state.cityArr &&
                            this.state.cityArr.map((val, index) => {
                              return (
                                <Option key={index} value={val._id}>
                                  {val.cityName}
                                </Option>
                              );
                            })}
                        </Select>
                        {/*<Input*/}
                        {/*placeholder={'City'}*/}

                        {/*value={this.state.city}*/}
                        {/*onChange={ei => {*/}
                        {/*this.setState({city: ei.target.value})*/}
                        {/*}}*/}
                        {/*/>*/}
                      </div>

                      <div>
                        <Button
                          style={{
                            marginTop: 25,
                            marginBottom: 23,
                          }}
                          icon="plus"
                          type="primary"
                          size={"small"}
                          onClick={() => {
                            if (!this.state.country) {
                              return notification.error({
                                message: "Choose Country",
                              });
                            }

                            if (this.state.country) {
                              let tt = this.state.totalPreference;
                              tt.push({
                                country: this.state.country,
                                city: this.state.city,
                              });
                              this.setState(
                                {
                                  totalPreference: tt,
                                  edited: true,
                                  city: null,
                                  country: null,
                                },
                                () => { }
                              );
                            }
                          }}
                        >
                          {/* ADD TO PREFERENCES */}
                        </Button>
                      </div>
                      {/*<div>*/}
                      {/*<Select*/}
                      {/*placeholder={'Country'}*/}
                      {/*value={this.state.country}*/}
                      {/*onChange={ei => {*/}
                      {/*this.setState({country: ei})*/}
                      {/*}}>*/}
                      {/*{this.state.countryArr.map((val, index) => {*/}
                      {/*return (*/}
                      {/*<Option key={index} value={val._id}>*/}
                      {/*{val.display}*/}
                      {/*</Option>*/}
                      {/*)*/}
                      {/*})}*/}
                      {/*</Select>*/}
                      {/*</div>*/}
                      {/*<div>*/}
                      {/*<Input*/}
                      {/*placeholder={'City'}*/}
                      {/*value={this.state.city}*/}
                      {/*onChange={ei => {*/}
                      {/*this.setState({city: ei.target.value})*/}
                      {/*}}*/}
                      {/*/>*/}
                      {/*</div>*/}

                      {/*<div>*/}
                      {/*<Button*/}
                      {/*style={{*/}
                      {/*marginTop: 4,*/}
                      {/*marginBottom: 23,*/}
                      {/*marginLeft: 70*/}
                      {/*}}*/}
                      {/*size={'small'}*/}
                      {/*onClick={() => {*/}
                      {/*if (!this.state.country) {*/}
                      {/*return notification.error({*/}
                      {/*message: 'Choose Country'*/}
                      {/*})*/}
                      {/*}*/}

                      {/*if (!this.state.city) {*/}
                      {/*return notification.error({*/}
                      {/*message: 'Enter city'*/}
                      {/*})*/}
                      {/*}*/}

                      {/*let tt = this.state.totalPreference*/}

                      {/*tt.push({*/}
                      {/*country: this.state.country,*/}
                      {/*city: this.state.city*/}
                      {/*})*/}
                      {/*this.setState({*/}
                      {/*totalPreference: tt,*/}
                      {/*city: null,*/}
                      {/*country: null*/}
                      {/*})*/}

                      {/*}}>*/}
                      {/*ADD TO PREFERENCE*/}
                      {/*</Button>*/}
                      {/*</div>*/}
                    </div>
                  </div>
                </Row>
                <Row>
                  <Col style={{ backgroundColor: "white" }} span={24}>
                    <Table
                      size={"small"}
                      pagination={{
                        defaultPageSize: 10,
                        showSizeChanger: false,
                        showQuickJumper: false,
                      }}
                      bordered={true}
                      columns={colum}
                      dataSource={this.state.totalPreference}
                    />
                  </Col>
                </Row>
              </div>
              <div>
                <Col span={5} />
                <Col>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: 10, marginTop: 10 }}
                    loading={this.props.loading}
                  >
                    SAVE
                  </Button>
                </Col>
              </div>
            </Form>
          </TabPane>
          <TabPane tab="Qualification" key="4">
            <Form
              onSubmit={this.handleSubmitTab4}
              style={{ marginTop: 8 }}
              className={style.formCls}
            >
              <div>
                <Row>
                  <Col style={{ backgroundColor: "white", width: "100%" }}>
                    {" "}
                    <Quali
                      handleSubmit={(data) => {
                        let x = [...this.state.list, ...data];
                        x = _.uniqBy(x, "qualification");
                        this.setState({ list: x }, () => {
                          this.calculateGap()
                        });
                      }}
                    />
                    <Table
                      size={"small"}
                      pagination={{
                        defaultPageSize: 10,
                        showSizeChanger: false,
                        showQuickJumper: false,
                      }}
                      bordered={true}
                      columns={qualColumns}
                      dataSource={list}
                      scroll={{ x: 1200 }}
                    />
                  </Col>
                </Row>
              </div>
              <div>
                <Card title="Refer a friend">
                  <div className={"referenceItem"}>
                    <Link target="_default" to={`/raw/inquiry/add/`}>
                      Click to add
                    </Link>
                  </div>
                  <div className={"referenceItem refer-friend-section"}>
                    <div>
                      <Row>
                        <Col span={24}>Name </Col>
                        <Col span={24}>
                          <Input
                            value={this.state.name}
                            onChange={(ei) => {
                              this.setState({ name: ei.target.value });
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <Row>
                        <Col span={24}>Mobile No </Col>
                        <Col span={24}>
                          <InputNumber
                            value={this.state.mobile}
                            style={{ width: 200 }}
                            onChange={(ei) => {
                              this.setState({ mobile: ei });
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <Row>
                        <Col span={24}>Country </Col>
                        <Col span={24}>
                          <Select
                            placeholder="Select Country"
                            showSearch={true}
                            optionFilterProp="children"
                            value={
                              this.state.country1
                                ? this.state.country1._id
                                : undefined
                            }
                            onChange={(ei) => {
                              let singleCountry = _.find(
                                this.state.countryArr,
                                (item) => {
                                  return item._id == ei;
                                }
                              );
                              this.setState({
                                country1: singleCountry,
                                city: null,
                              });
                            }}
                          >
                            {this.state.countryArr.map((val, index) => {
                              return (
                                <Option key={index} value={val._id}>
                                  {val.countryName}
                                </Option>
                              );
                            })}
                          </Select>

                          {/*  <Button
                      style={{
                        marginTop: 25,
                        marginBottom: 23,
                        marginLeft: 70
                      }}
                      size={'small'}
                      onClick={() => {

                        if (!this.state.country) {
                          return notification.error({
                            message: 'Choose Country'
                          })
                        }

                        if (!this.state.name) {
                          return notification.error({
                            message: 'Enter name'
                          })
                        }
                        if (!this.state.mobile) {
                          return notification.error({
                            message: 'Enter mobile'
                          })
                        }

                        if (this.state.country && this.state.name, this.state.mobile) {
                          let tt = this.state.totalData
                          tt.push({
                            country: this.state.country,
                            name: this.state.name,
                            mobile: this.state.mobile
                          })
                          console.log(tt, "tttttttttttttttttttttttttttttttttttttttttttt")
                          this.setState({
                            totalData: tt,
                            country: null,
                            name: null,
                            mobile: null

                          }, () => {

                          })

                        }


                      }}>
                      ADD REFRENCES
                    </Button>*/}
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <Button
                        style={{
                          marginBottom: "9px",
                          marginTop: "17px",
                          height: "30px",
                        }}
                        size={"small"}
                        type="primary"
                        onClick={() => {
                          if (!this.state.country1) {
                            return notification.error({
                              message: "Choose Country",
                            });
                          }

                          if (!this.state.name) {
                            return notification.error({
                              message: "Enter name",
                            });
                          }
                          if (!this.state.mobile) {
                            return notification.error({
                              message: "Enter mobile",
                            });
                          }

                          if (
                            (this.state.country1 && this.state.name,
                              this.state.mobile)
                          ) {
                            let tt = this.state.totalData;
                            tt.push({
                              country: this.state.country1,
                              name: this.state.name,
                              mobile: this.state.mobile,
                            });
                            this.setState(
                              {
                                totalData: tt,
                                country1: null,
                                name: null,
                                mobile: null,
                              },
                              () => { }
                            );
                          }
                        }}
                      >
                        ADD
                      </Button>
                    </div>
                  </div>

                  <Row style={{ marginTop: 40, display: "none" }}>
                    <Col span={24}>
                      <Table
                        bordered={true}
                        rowKey={(x) => x.mobile}
                        columns={refColumns}
                        dataSource={this.state.totalData || []}
                        pagination={false}
                      />
                    </Col>
                  </Row>
                </Card>
              </div>
              <div>
                <Card title="Job Details">
                  <div>
                    <Row>
                      <Col span={8}>
                        <Input
                          placeholder={"Job Title"}
                          value={this.state.jobTitle}
                          onChange={(ei) => {
                            this.setState({ jobTitle: ei.target.value });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <Input
                          placeholder={"Company"}
                          value={this.state.company}
                          onChange={(ei) => {
                            this.setState({ company: ei.target.value });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <Input
                          placeholder={"Contact Person"}
                          value={this.state.contactPerson}
                          onChange={(ei) => {
                            this.setState({ contactPerson: ei.target.value });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <Input
                          placeholder={"Phone"}
                          value={this.state.phone}
                          onChange={(ei) => {
                            this.setState({ phone: ei.target.value });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <DatePicker
                          placeholder={"From"}
                          value={this.state.from}
                          style={{ width: "100%" }}
                          onChange={(v) => {
                            this.setState({ from: v })
                          }} />
                        {/* <Input
                          placeholder={"From"}
                          value={this.state.from}
                          onChange={(ei) => {
                            this.setState({ from: ei.target.value });
                          }}
                        /> */}
                      </Col>
                      <Col span={8}>
                        <DatePicker
                          placeholder={"To"}
                          value={this.state.to}
                          style={{ width: "100%" }}
                          onChange={(v) => {
                            this.setState({ to: v })
                          }} />
                        {/* <Input
                          placeholder={"To"}
                          value={this.state.to}
                          onChange={(ei) => {
                            this.setState({ to: ei.target.value });
                          }}
                        /> */}
                      </Col>
                    </Row>
                    <div>
                      <Button
                        style={{
                          marginBottom: "9px",
                          marginTop: "17px",
                          height: "30px",
                        }}
                        size={"small"}
                        type="primary"
                        onClick={() => {
                          let {
                            jobTitle,
                            company,
                            contactPerson,
                            to,
                            from,
                            phone,
                          } = this.state;

                          if (!jobTitle) {
                            return notification.error({
                              message: "Enter Job Title",
                            });
                          }

                          if (!company) {
                            return notification.error({
                              message: "Enter company",
                            });
                          }
                          if (!contactPerson) {
                            return notification.error({
                              message: "Enter contact person",
                            });
                          }
                          if (!phone) {
                            return notification.error({
                              message: "Enter phone no",
                            });
                          }
                          if (!from) {
                            return notification.error({
                              message: "Enter from",
                            });
                          }
                          if (!to) {
                            return notification.error({
                              message: "Enter to",
                            });
                          }

                          if (
                            jobTitle &&
                            company &&
                            contactPerson &&
                            to &&
                            from &&
                            phone
                          ) {
                            let tt = this.state.totalData1;
                            tt.push({
                              to: moment(this.state.to).format('DD-MM-YYYY'),
                              from: moment(this.state.FormData).format('DD-MM-YYYY'),
                              phone,
                              jobTitle,
                              company,
                              contactPerson,
                            });
                            this.setState(
                              {
                                totalData1: tt,
                                contactPerson: null,
                                company: null,
                                jobTitle: null,
                                phone: null,
                                from: null,
                                to: null,
                              },
                              () => {
                                this.calculateGap()
                              }
                            );
                          }
                        }}
                      >
                        Add Employment
                      </Button>
                    </div>
                  </div>

                  <Row style={{ marginTop: 40 }}>
                    <Col span={24}>
                      <Table
                        bordered={true}
                        rowKey={(x) => x.phone}
                        columns={jobColumns}
                        dataSource={this.state.totalData1 || []}
                        pagination={false}
                      />
                    </Col>
                  </Row>
                </Card>
              </div>
              <div>
                <Card title={"Education / Experience Gap"} bordered={true} style={{ marginTop: 10 }}>
                  <p>{this.state.gapTotal}</p>
                </Card>
              </div>
              <div>
                <Col span={5} />
                <Col>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: 10, marginTop: 10 }}
                    loading={this.props.loading}
                  >
                    SAVE
                  </Button>
                </Col>
              </div>
            </Form>
          </TabPane>
        </Tabs>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  allChannelPartners: global.allChannelPartners,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inquiry);
